/* Ability Warehouse theme scripts */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var money = function (cents) {
    return new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format((cents || 0) / 100);
  };

  /* ---------- Mobile drawer ---------- */
  var drawer = $('[data-menu]');
  var opener = $('[data-menu-open]');
  function openMenu() {
    if (!drawer) return;
    drawer.hidden = false;
    document.body.classList.add('no-scroll');
    if (opener) opener.setAttribute('aria-expanded', 'true');
    var close = $('[data-menu-close]', drawer);
    if (close) close.focus();
  }
  function closeMenu() {
    if (!drawer || drawer.hidden) return;
    drawer.hidden = true;
    document.body.classList.remove('no-scroll');
    if (opener) { opener.setAttribute('aria-expanded', 'false'); opener.focus(); }
  }
  if (opener) opener.addEventListener('click', openMenu);
  $$('[data-menu-close]').forEach(function (b) { b.addEventListener('click', closeMenu); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeMenu(); closeMega(); }
  });
  window.addEventListener('resize', function () { if (window.innerWidth >= 990) closeMenu(); });

  /* ---------- Mega menu (click / keyboard; hover handled in CSS) ---------- */
  var mega = $('[data-mega]');
  var megaBtn = $('[data-mega-toggle]');
  function closeMega() {
    if (!mega) return;
    mega.classList.remove('is-open');
    if (megaBtn) megaBtn.setAttribute('aria-expanded', 'false');
  }
  if (megaBtn) {
    megaBtn.addEventListener('click', function () {
      var open = !mega.classList.contains('is-open');
      mega.classList.toggle('is-open', open);
      megaBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    document.addEventListener('click', function (e) { if (mega && !mega.contains(e.target)) closeMega(); });
  }

  /* ---------- Auto-submit selects / cart quantities ---------- */
  $$('[data-autosubmit]').forEach(function (el) {
    el.addEventListener('change', function () { if (el.form) el.form.submit(); });
  });

  /* ---------- Hero switcher ---------- */
  $$('[data-hero]').forEach(function (hero) {
    var img = $('.hero__media img', hero);
    var title = $('[data-hero-title]', hero);
    var price = $('[data-hero-price]', hero);
    var links = [$('[data-hero-link]', hero), $('[data-hero-link2]', hero)];
    $$('[data-hero-thumb]', hero).forEach(function (btn) {
      btn.addEventListener('click', function () {
        $$('[data-hero-thumb]', hero).forEach(function (b) { b.classList.remove('is-active'); b.setAttribute('aria-pressed', 'false'); });
        btn.classList.add('is-active'); btn.setAttribute('aria-pressed', 'true');
        if (img) { img.src = btn.dataset.img; img.srcset = btn.dataset.srcset; img.alt = btn.dataset.title; }
        if (title) title.textContent = btn.dataset.title;
        var tpl = $('template', btn);
        if (price && tpl) price.innerHTML = tpl.innerHTML;
        links.forEach(function (a) { if (a) a.href = btn.dataset.url; });
      });
    });
  });

  /* ---------- Product gallery ---------- */
  var mainImg = document.getElementById('GalleryMain');
  $$('[data-gallery-thumb]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!mainImg) return;
      mainImg.src = btn.dataset.src; mainImg.srcset = btn.dataset.srcset;
      $$('[data-gallery-thumb]').forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
    });
  });

  /* ---------- Product "How many do I need?" place chips ---------- */
  $$('[data-calc] [data-places]').forEach(function (card) {
    var form = card.closest('form');
    var price = parseInt(card.dataset.price, 10) || 0;
    var compare = parseInt(card.dataset.compare, 10) || 0;
    var qty = $('[data-qty]', card);
    var chips = $$('[data-place]', card);
    var manual = false;
    function chosen() { return chips.filter(function (c) { return c.getAttribute('aria-pressed') === 'true'; }); }
    function update() {
      var on = chosen();
      var n = Math.max(1, parseInt(qty.value, 10) || 1);
      if (!manual && on.length) { n = on.length; qty.value = n; }
      $('[data-out-area]', card).textContent = on.length;
      var need = $('[data-out-need]', card);
      if (need) need.textContent = on.length ? on.map(function (c) { return c.dataset.place; }).join(', ') + ' → ' + n + (n === 1 ? ' item' : ' items') : '';
      var pr = form && form.querySelector('[data-variant-picker]');
      if (pr) { var sb = document.querySelector('[data-sticky-buy]'); if (sb && sb.dataset.price) price = parseInt(sb.dataset.price, 10) || price; }
      $('[data-out-total]', card).textContent = money(n * price);
      var save = $('[data-out-save]', card);
      if (save) save.textContent = money(n * Math.max(0, compare - price));
    }
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        var on = c.getAttribute('aria-pressed') === 'true';
        c.setAttribute('aria-pressed', on ? 'false' : 'true');
        c.classList.toggle('is-on', !on);
        manual = false; update();
      });
    });
    qty.addEventListener('input', function () { manual = true; update(); });
    document.addEventListener('aw:variant', function () { setTimeout(update, 0); });
    update();
  });

  /* ---------- Quantity steppers (product form) ---------- */
  $$('[data-qty-step]').forEach(function (b) {
    b.addEventListener('click', function () {
      var input = b.parentNode.querySelector('input');
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.qtyStep, 10));
      input.dispatchEvent(new Event('input', { bubbles: true }));
    });
  });

  /* ---------- Tabs (funding guide) ---------- */
  $$('[data-tabs]').forEach(function (wrap) {
    var tabs = $$('[data-tab]', wrap), panels = $$('[data-panel]', wrap), imgs = $$('[data-panel-img]', wrap);
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        tabs.forEach(function (x, j) { x.setAttribute('aria-selected', j === i ? 'true' : 'false'); });
        panels.forEach(function (p, j) { p.hidden = j !== i; });
        imgs.forEach(function (p, j) { p.hidden = j !== i; });
      });
    });
  });

  /* ---------- Weight-rating guide (chip → card) ---------- */
  $$('[data-slip-chips]').forEach(function (chips) {
    var section = chips.closest('section');
    $$('[data-slip]', chips).forEach(function (b) {
      b.addEventListener('click', function () {
        $$('[data-slip]', chips).forEach(function (x) { x.classList.toggle('is-on', x === b); x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        $$('[data-slip-card]', section).forEach(function (c) { c.hidden = c.dataset.slipCard !== b.dataset.slip; });
      });
    });
  });

  /* ---------- Product finder (two questions) ---------- */
  $$('[data-finder]').forEach(function (f) {
    var base = f.dataset.base, where = null;
    var steps = $$('[data-step]', f), dots = $$('.finder__dots span', f);
    function show(n) {
      steps.forEach(function (s) { s.hidden = s.dataset.step !== String(n); });
      dots.forEach(function (d, i) { d.classList.toggle('is-on', i < n); });
    }
    $$('[data-where]', f).forEach(function (b) {
      b.addEventListener('click', function () {
        where = b.dataset.where;
        var l = $('[data-where-label]', f); if (l) l.textContent = '— ' + b.dataset.label;
        show(2);
      });
    });
    $$('[data-look]', f).forEach(function (b) {
      b.addEventListener('click', function () {
        dots.forEach(function (d) { d.classList.add('is-on'); });
        var look = b.dataset.look;
        window.location.href = base + '/' + where + (look && look !== 'all' ? '+' + look : '');
      });
    });
    var back = $('[data-back]', f);
    if (back) back.addEventListener('click', function () { show(1); });
  });

  /* ---------- Product recommendations ---------- */
  $$('[data-recs]').forEach(function (el) {
    if (el.children.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      io.disconnect();
      fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var inner = tmp.querySelector('[data-recs]');
        if (inner && inner.innerHTML.trim()) el.innerHTML = inner.innerHTML;
      }).catch(function () {});
    }, { rootMargin: '0px 0px 400px 0px' });
    io.observe(el);
  });

  /* Tools page lives in assets/tools.js; Product Match in assets/product-match.js */
})();